import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { MachineModuleService } from '../../../shared/services';
import { Machine } from '../../../shared/models';
import * as _ from 'lodash';

@Component({
  templateUrl: './new-machine-page.component.html',
  standalone: false
})
export class NewMachinePageComponent extends BaseModalPageComponent implements OnInit {
  public processing = false;
  public productLines: any = [];
  public models: any = [];
  public clientNumber: string;

  constructor(location: Location, private router: Router, private route: ActivatedRoute, private machinesService: MachineModuleService) {
    super(location);
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.clientNumber = params['clientNumber'];
    });
  }

  create(machine: Machine): void {
    this.processing = true;
    this.machinesService.createMachine(this.clientNumber, machine).subscribe((el) => {
      this.processing = false;
      this.router.navigate([this.appRoute, 'machines', el.serialNumber]);
    });
  }

  goToBack() {
    this.router.navigate([this.appRoute, 'customers', this.clientNumber, 'machines']);
  }
}
